import { __extends } from "tslib";
import { WebXRAbstractMotionController } from "./webXRAbstractMotionController.js";
import { Mesh } from "../../Meshes/mesh.js";
import { Quaternion } from "../../Maths/math.vector.js";
/**
 * A generic trigger-only motion controller for WebXR
 */
var WebXRGenericTriggerMotionController = /** @class */ (function (_super) {
    __extends(WebXRGenericTriggerMotionController, _super);
    function WebXRGenericTriggerMotionController(scene, gamepadObject, handedness) {
        var _this = _super.call(this, scene, GenericTriggerLayout[handedness], gamepadObject, handedness) || this;
        _this.profileId = WebXRGenericTriggerMotionController.ProfileId;
        return _this;
    }
    WebXRGenericTriggerMotionController.prototype._getFilenameAndPath = function () {
        return {
            filename: "generic.babylon",
            path: "https://controllers.babylonjs.com/generic/",
        };
    };
    WebXRGenericTriggerMotionController.prototype._getModelLoadingConstraints = function () {
        return true;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    WebXRGenericTriggerMotionController.prototype._processLoadedModel = function (meshes) {
        // nothing to do
    };
    WebXRGenericTriggerMotionController.prototype._setRootMesh = function (meshes) {
        var _this = this;
        this.rootMesh = new Mesh(this.profileId + " " + this.handedness, this.scene);
        meshes.forEach(function (mesh) {
            mesh.isPickable = false;
            if (!mesh.parent) {
                mesh.setParent(_this.rootMesh);
            }
        });
        this.rootMesh.rotationQuaternion = Quaternion.FromEulerAngles(0, Math.PI, 0);
    };
    WebXRGenericTriggerMotionController.prototype._updateModel = function () {
        // no-op
    };
    /**
     * Static version of the profile id of this controller
     */
    WebXRGenericTriggerMotionController.ProfileId = "generic-trigger";
    return WebXRGenericTriggerMotionController;
}(WebXRAbstractMotionController));
export { WebXRGenericTriggerMotionController };
// https://github.com/immersive-web/webxr-input-profiles/blob/master/packages/registry/profiles/generic/generic-trigger-touchpad-thumbstick.json
var GenericTriggerLayout = {
    left: {
        selectComponentId: "xr-standard-trigger",
        components: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            "xr-standard-trigger": {
                type: "trigger",
                gamepadIndices: {
                    button: 0,
                },
                rootNodeName: "xr_standard_trigger",
                visualResponses: {},
            },
        },
        gamepadMapping: "xr-standard",
        rootNodeName: "generic-trigger-left",
        assetPath: "left.glb",
    },
    right: {
        selectComponentId: "xr-standard-trigger",
        components: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            "xr-standard-trigger": {
                type: "trigger",
                gamepadIndices: {
                    button: 0,
                },
                rootNodeName: "xr_standard_trigger",
                visualResponses: {},
            },
        },
        gamepadMapping: "xr-standard",
        rootNodeName: "generic-trigger-right",
        assetPath: "right.glb",
    },
    none: {
        selectComponentId: "xr-standard-trigger",
        components: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            "xr-standard-trigger": {
                type: "trigger",
                gamepadIndices: {
                    button: 0,
                },
                rootNodeName: "xr_standard_trigger",
                visualResponses: {},
            },
        },
        gamepadMapping: "xr-standard",
        rootNodeName: "generic-trigger-none",
        assetPath: "none.glb",
    },
};
//# sourceMappingURL=webXRGenericMotionController.js.map